import { Box } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

type AutogiroSignedStatusProps = {
  isSigned: boolean;
};

export const AutogiroSignedStatus = (props: AutogiroSignedStatusProps) => {
  const { isSigned } = props;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', '& .MuiChip-root': { borderRadius: 1 } }}>
      {!isSigned && <CheckCircle sx={{ color: (thm) => thm.palette.grey[200] }} fontSize='small' />}
      {isSigned && <CheckCircle sx={{ color: (thm) => thm.palette.success.dark }} fontSize='small' />}
    </Box>
  );
};
